import React from 'react';
import {
    Modal,
    Button,
    Text,
    Group,
    Avatar,
    Table,
    Box,
    Stack,
    Badge,
    Divider,
    ActionIcon,
} from '@mantine/core';
import { IconLock } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import { translate } from "../utils/i18n";

export const SuperAdminRoleAssignmentModal = ({ 
    opened, 
    onClose, 
    assignedSuperAdmins = [] 
}) => {
    const navigate = useNavigate();

    // Group super admins by project
    const groupedByProject = assignedSuperAdmins.reduce((acc, item) => {
        if (!acc[item.project]) {
            acc[item.project] = [];
        }
        acc[item.project].push(item);
        return acc;
    }, {});

    const handleGoToSettings = () => {
        onClose();
        navigate('/workspace/projects');
    };

    // Build table rows: each project with its users
    const tableRows = Object.entries(groupedByProject).map(([projectName, users]) => {
        return users.map((user, index) => (
            <Table.Tr key={`${projectName}-${user.user_id}-${index}`}>
                {index === 0 && (
                    <Table.Td rowSpan={users.length} ta="start">
                        {projectName}
                    </Table.Td>
                )}
                <Table.Td>
                    <Group gap="sm">
                        <Avatar 
                            src={user.avatar}
                            name={user.username} 
                            radius="xl" 
                            size={32}
                            color="blue"
                        />
                        <Stack gap={2}>
                            <Text fw={500} size="sm">
                                {user.username}
                            </Text>
                            <Text size="xs" c="dimmed">
                                {user.email}
                            </Text>
                        </Stack>
                    </Group>
                </Table.Td>
            </Table.Tr>
        ));
    }).flat();

    return (
        <Modal
            opened={opened}
            onClose={onClose}
            title={
                <Group spacing="sm">
                    <ActionIcon size={'md'} variant="filled" radius="xl" aria-label="Settings" color="#ED7D31">
                        <IconLock style={{ width: '70%', height: '70%' }} stroke={1.5}  />
                    </ActionIcon>
                    
                    <Text fw={600} size="lg">
                        {translate('Project Role Assign')}
                    </Text>
                </Group>
            }
            centered
            size="xl"
            radius="md"
            withCloseButton={true}
        >
            <Divider mb="xs" />
            <Stack gap="md">
                <Text size="sm" c="dimmed">
                    {translate('The following users are missing assigned roles on their projects. Please update their roles.')}
                </Text>

                <Box
                    style={{
                        overflowX: 'auto',
                        border: '1px solid #E0E0E0',
                        borderRadius: '8px',
                    }}
                >
                    <Table.ScrollContainer h={400}>
                    <Table striped highlightOnHover horizontalSpacing="sm" verticalSpacing="md">
                        <Table.Thead>
                            <Table.Tr>
                                <Table.Th fw={600}>
                                    {translate('Project Name')}
                                </Table.Th>
                                <Table.Th fw={600}>
                                    {translate('User Name')}
                                </Table.Th>
                            </Table.Tr>
                        </Table.Thead>
                        <Table.Tbody>
                            {tableRows}
                        </Table.Tbody>
                    </Table>
                    </Table.ScrollContainer>
                </Box>

                <Button
                    fullWidth
                    color="#ED7D31"
                    size="md"
                    fw={500}
                    onClick={handleGoToSettings}
                >
                    {translate('Go to Settings Workspace & Project')}
                </Button>
            </Stack>
        </Modal>
    );
};